module.exports = __webpack_public_path__ + "static/media/nick_on_computer.d87e9bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/nick_on_computer.jpg
// module id = 265
// module chunks = 0